import React, { useState, useEffect } from "react";

//import * as ReactBoostrap from "react-bootstrap";
// import * as ANTD from "antd";
import {
  Button,
  Row,
  Card,
  Col,
  Form,
  message,
  Input,
  Radio,
  Upload,
  Select,
  Table,
  Modal,
  Layout,
  Popconfirm,
  Switch,
  Image,
  Collapse,
  InputNumber,
  DatePicker,
} from "antd";
import {
  PlusCircleFilled,
  UploadOutlined,
  LoadingOutlined,
  PlusOutlined,
  EditOutlined,
  DeleteOutlined,
  InfoCircleOutlined,
} from "@ant-design/icons";
import HelpInfoHelper from "../../common/HelpInfoHelper/HelpInfoHelper";
import "./EmbassyDetails.scss";
import excel from "../assets/vector-icons/excel.png";
import pdf from "../assets/vector-icons/pdf.png";
// import word from "../assets/vector-icons/word.png";
import search from "../assets/vector-icons/search.png";
import exchange from "../assets/vector-icons/exchange.png";
//import BootstrapTable from "react-bootstrap-table-next";
//import paginationFactory from "react-bootstrap-table2-paginator";
//import filterFactory, { textFilter } from 'react-bootstrap-table2-filter';
//import 'react-bootstrap-table-next/dist/react-bootstrap-table2.min.css'
import ApiClient from "../../helpers/ApiClient";

const EmbassyDetails = () => {
  const { Header, Footer, Sider, Content } = Layout;
  const [modalVisible, setModalVisible] = useState(false);
  const { Panel } = Collapse;
  const [isEditMode, setIsEditMode] = useState(true);
  const [id, setId] = useState(-1);
  const [form] = Form.useForm();
  const [formLayout, setFormLayout] = useState("vertical");
  const { TextArea } = Input;

  const showModal = () => {
    setModalVisible({
      visible: true,
    });
  };

  const handleAddClick = () => {
    form.resetFields();
    showModal();
    setIsEditMode(false);
  };
  const handleEditClick = (rec) => {
    form.setFieldsValue({
      CarType: rec.CarType,
      CarDescription: rec.CarDescription,
      Status: rec.Status,
    });
    setFormData({ ...rec, CarTypeID: rec.CarTypeID, CarType: rec.CarType });

    setIsEditMode(true);

    showModal();
  };
  const initialFormData = {
    name: "",
    description: "",
    status: "",
  };
  const [dataSource, setDataSource] = useState([]);
  const getAllCarType = () => {
    // ApiClient.get("carextranet/getallcartype").then((res) => {
    //   if (res.status == 200) {
    //     setDataSource(res.data);
    //   }
    // });
  };
  useEffect(() => {
    // getAllCarType();
  }, []);

  const [formData, setFormData] = useState({});
  console.log(formData, "editform datya");
  const submitNewCarType = (formvalues) => {
    // setFormData(formvalues);
    // ApiClient.post("carextranet/createcartype", formvalues).then((response) => {
    //   if (response.status === 200) {
    //     setModalVisible(false);
    //     message.success("Cartype created successfully");
    //     setFormData({ initialFormData });
    //     getAllCarType();
    //     form.resetFields();
    //   } else {
    //     message.error(" Error Creating CarType ");
    //   }
    // });
  };

  const handleSubmit = (formvalues) => {
    if (isEditMode) {
      submitUpdateCarType(formvalues);
    } else {
      submitNewCarType(formvalues);
    }
  };

  const submitUpdateCarType = (formvalues) => {
    // setFormData(formvalues);

    const updatedFormData = {
      ...formData,
      ...formvalues,
    };
    console.log("formData", formData.CarTypeID);

    // ApiClient.put(
    //   "carextranet/updatecartype/" + formData.CarTypeID,
    //   {},
    //   updatedFormData
    // ).then((response) => {
    //   console.log(response);
    //   if (response.status === 200) {
    //     setModalVisible(false);
    //     message.success("CarType updated successfully");
    //     setFormData({ initialFormData });
    //     getAllCarType();
    //     form.resetFields();
    //   } else {
    //     message.error(" Error Updating CarType ");
    //   }
    // });
  };

  const tailLayout = {
    wrapperCol: { offset: 8, span: 16 },
  };

  const deleteCarType = (id) => {
    // ApiClient.delete("carextranet/deletecartype/" + id).then((res) => {
    //   if (res.status == 200) {
    //     message.success("CarType Deleted  successfully", 3);
    //     getAllCarType();
    //   }
    // });
  };

  const tableActions = (rec) => {
    return (
      <div style={{ display: "flex", justifyContent: "space-evenly" }}>
        <div className="edit-icon" style={{ textAlign: "center" }}>
          <EditOutlined
            onClick={() => handleEditClick(rec)}
            style={{ color: "#1890ff", fontSize: "20px", textAlign: "center" }}
          />
        </div>
        <div className="edit-icon" style={{ textAlign: "center" }}>
          <Popconfirm
            title="Are you sure to delete?"
            onConfirm={() => deleteCarType(rec.CarTypeID)}
          >
            <DeleteOutlined
              style={{ color: "red", fontSize: "20px", textAlign: "center" }}
            />
          </Popconfirm>
        </div>
      </div>
    );
  };
  const { Option } = Select;
  const prefixSelector = (
    <Form.Item name="prefix" noStyle>
      <Select style={{ width: 80 }} placeholder="+91">
        <Option value="86">+86</Option>
        <Option value="87">+87</Option>
      </Select>
    </Form.Item>
  );
  const config = {
    rules: [{ type: "object", required: true, message: "Please select time!" }],
  };
  const columns = [
    {
      title: "Car Type",
      dataIndex: "CarType",
    },

    {
      title: "Description",
      dataIndex: "CarDescription",
    },
    {
      title: "Created Date",
      dataIndex: "CreatedDate",
    },
    {
      title: "LastModified Date",
      dataIndex: "ModifiedDate",
    },

    {
      title: "Status",
      render: (currentItem) => handelStatus(currentItem),
    },
    {
      title: "Actions",
      render: (rec) => {
        return tableActions(rec);
      },
    },
  ];

  const handelStatus = (data) => {
    if (data.Status == 1) {
      return (
        <Switch
          checkedChildren="Active"
          unCheckedChildren="Inactive"
          defaultChecked
          onChange={() => changeStatus(data, 0)}
        />
      );
    } else {
      return (
        <Switch
          checkedChildren="Active"
          unCheckedChildren="Inactive"
          onChange={() => changeStatus(data, 1)}
        />
      );
    }
  };

  const changeStatus = (info) => {
    // let obj = {
    //   Id: info.CarTypeID,
    //   status: Status,
    // };
    // ApiClient.put("carextranet/toggleCarTypeStatus/" + info.CarTypeID)
    //   .then((response) => {
    //     if (response.status == 200) {
    //       message.success("Car Type Status updated successfully !");
    //       getAllCarType();
    //     } else {
    //       message.error(response.message, 3);
    //     }
    //   })
    //   .catch((error) => {
    //     console.error(error);
    //   });
  };

  return (
    <div className="promo">
      <div className="manage-markup-section">
        <Content className="admin-container">
          <Row>
            <Col span={24}>
              <div className="card-bt-gap">
                <Card bordered={false}>
                  <div className="card-add-heading">
                    <div className="rows-count">
                      <div>
                        <h5>
                          Embassy Details{" "}
                          <HelpInfoHelper screenName={"/admin/cartypes"} />
                        </h5>
                        <p></p>
                      </div>
                    </div>
                    <div className="action-images">
                      <img src={search} alt="search" />
                      <img src={excel} alt="excel" />
                      <img src={pdf} alt="pdf" />
                      <p className="add-deposit-icon" onClick={handleAddClick}>
                        <PlusCircleFilled />
                      </p>
                    </div>
                  </div>
                  {!dataSource === null ? (
                    <div>
                      <Table
                        className="table-scroll-none"
                        bordered
                        dataSource={dataSource}
                        columns={columns}
                        pagination={{
                          defaultPageSize: 25,
                          showSizeChanger: true,
                          pageSizeOptions: ["25", "50", "100", "125"],
                        }}
                      />
                    </div>
                  ) : (
                    <b>No record Found</b>
                  )}
                </Card>
              </div>
            </Col>
          </Row>
        </Content>
      </div>

      <Modal
        title="Embassy Details"
        className="promo-modal-header"
        visible={modalVisible}
        onOk={(e) => setModalVisible(false)}
        onCancel={(e) => setModalVisible(false)}
        footer={null}
        width={"1100px"}
      >
        <Form
          form={form}
          layout={formLayout}
          initialValues={{ layout: formLayout }}
          name="basic"
          initialValues={{ remember: true }}
          onFinish={handleSubmit}
          // onFinishFailed={onFinishFailed}
        >
          <Row gutter={16}>
            <Col md={6} xs={24}>
              <Form.Item
                label="Visa "
                rules={[{ required: true }]}
                name="Visa "
              >
                <Select placeholder="Please Select Your Visa ">
                  <Option value="BusinessVisa">Business Visa</Option>
                  <Option value="ProjectVisa">Project Visa</Option>
                </Select>
              </Form.Item>
            </Col>
            <Col md={6} xs={24}>
              <Form.Item
                label="Basic Requirements to visit"
                rules={[{ required: true }]}
                name="Basic Requirements to visit"
              >
                <Select placeholder="Please Select Your Requirement">
                  <Select.Option value="PanCard">Pan Card</Select.Option>
                  <Select.Option value="AdhaarCard">Adhaar Card</Select.Option>
                </Select>
              </Form.Item>
            </Col>
            <Col md={6} xs={24}>
              <Form.Item
                label="Travel Checklist"
                rules={[{ required: true }]}
                name="TravelChecklist"
              >
                <Select placeholder="Please Select Your Travel Checklist">
                  <Select.Option value="EmploymentVisa">
                    Employment Visa
                  </Select.Option>
                  <Select.Option value="BusinessVisa">
                    Business Visa
                  </Select.Option>
                  <Select.Option value="ProjectVisa">
                    Project Visa
                  </Select.Option>
                </Select>
              </Form.Item>
            </Col>

            <Col md={6} xs={24}>
              <Form.Item
                name="EmbassyAddress"
                label="Embassy Address"
                rules={[
                  {
                    required: true,
                    message: "Please input your Embassy Address",
                  },
                ]}
              >
                <Input placeholder="Please enter your Embassy Address" />
              </Form.Item>
            </Col>

            <Col md={6} xs={24}>
              <Form.Item
                name="EmbassyContactnumbers"
                label="Embassy Contact Numbers"
                rules={[
                  {
                    required: true,
                    message: "Please input your Embassy Contact numbers",
                  },
                ]}
              >
                <Input placeholder="Please enter your Embassy Contact numberss" />
              </Form.Item>
            </Col>
            <Col md={6} xs={24}>
              <Form.Item
                name=" EmbassyEmailaddress"
                label=" Embassy Email Address"
                rules={[
                  {
                    required: true,
                    message: "Please input your  Embassy Email Address",
                  },
                ]}
              >
                <Input placeholder="Please enter your  Embassy Email Address" />
              </Form.Item>
            </Col>
            <Col md={6} xs={24}>
              <Form.Item
                name="Embassywebsiteaddress"
                label="Embassy Website Address"
                rules={[
                  {
                    required: true,
                    message: "Please input your  Embassy website address",
                  },
                ]}
              >
                <Input placeholder="Please enter your  Embassy website address" />
              </Form.Item>
            </Col>
          </Row>
          <Collapse accordion>
            <Panel header="Facts And Figure" key="1">
              <Row gutter={16}>
                <Col md={6} sm={6} xs={6}>
                  <Form.Item
                    label="Region"
                    rules={[{ required: true }]}
                    name="Region"
                  >
                    <Select placeholder="Please Select Your Region ">
                      <Option value="South">South</Option>
                      <Option value="North">North</Option>
                      <Option value="East">East</Option>
                    </Select>
                  </Form.Item>
                </Col>
                <Col md={6} sm={6} xs={6}>
                  <Form.Item
                    label="Capital"
                    rules={[{ required: true }]}
                    name="Capital"
                  >
                    <Select placeholder="Please Select Your Capital ">
                      <Option value="Shimla">Shimla</Option>
                      <Option value="Chandigarh">Chandigarh</Option>
                      <Option value="Delhi">Delhi</Option>
                    </Select>
                  </Form.Item>
                </Col>
                <Col md={6} sm={6} xs={6}>
                  <Form.Item
                    label="Major Cities"
                    rules={[{ required: true }]}
                    name="Major Cities"
                  >
                    <Select placeholder="Please Select Your Cities ">
                      <Option value="Shimla">Shimla</Option>
                      <Option value="Chandigarh">Chandigarh</Option>
                      <Option value="Delhi">Delhi</Option>
                    </Select>
                  </Form.Item>
                </Col>
                <Col md={6} sm={6} xs={6}>
                  <Form.Item
                    label="Language"
                    rules={[{ required: true }]}
                    name="Language"
                  >
                    <Input placeholder="Please Enter Your Language" />
                  </Form.Item>
                </Col>
                <Col md={6} sm={6} xs={6}>
                  <Form.Item
                    label="Area"
                    rules={[{ required: true, type: "Number" }]}
                    name="Area"
                  >
                    <Input placeholder="Please Enter Your Area" />
                  </Form.Item>
                </Col>
                <Col md={6} sm={6} xs={6}>
                  <Form.Item
                    label="Currency"
                    rules={[{ required: true }]}
                    name="Currency"
                  >
                    <Select placeholder="Please Select Your Currency">
                      <Option value="Rupay">Rupay</Option>
                      <Option value="Dinar">Dinar</Option>
                      <Option value="Dollar">Dollar</Option>
                    </Select>
                  </Form.Item>
                </Col>
                <Col md={6} sm={6} xs={6}>
                  <Form.Item
                    label="Main Airline"
                    rules={[{ required: true }]}
                    name="MainAirline"
                  >
                    <Select placeholder="Please Select Your Airline">
                      <Option value="Indigo">Indigo</Option>
                      <Option value="AirIndia">Air India</Option>
                      <Option value="GoAir">Go Air</Option>
                    </Select>
                  </Form.Item>
                </Col>
                <Col md={6} xs={24}>
                  <Form.Item
                    label="Independence Day"
                    name="Independence Day"
                    rules={[
                      {
                        required: true,
                        message: "Please select Independence Day",
                      },
                    ]}
                  >
                    <DatePicker
                      style={{ width: "100%" }}
                      placeholder="Select From date"
                    />
                  </Form.Item>
                </Col>
                <Col md={6} sm={6} xs={6}>
                  <Form.Item
                    label="International Airports"
                    rules={[{ required: true }]}
                    name="InternationalAirports"
                  >
                    <Select placeholder="Please Select Your International Airports">
                      <Option value="ChandigarhInternationalAirpot">
                        Chandigarh International Airpot
                      </Option>
                      <Option value="SardarSaheedBhagatSinghInt'lAirport">
                        Sardar Saheed Bhagat Singh Int'l Airport
                      </Option>
                      <Option value="IndiraGandhiInternationalAirport">
                        Indira Gandhi International Airport
                      </Option>
                    </Select>
                  </Form.Item>
                </Col>
                <Col md={6} sm={6} xs={6}>
                  <Form.Item
                    label="Best Time To Visit"
                    rules={[{ required: true }]}
                    name="BestTimeToVisit"
                  >
                    <Input placeholder="Please Enter Your Time To Visit April-June" />
                  </Form.Item>
                </Col>
              </Row>
            </Panel>
          </Collapse>
          <Form.Item {...tailLayout} style={{ marginBottom: 0, marginTop: 10 }}>
            <Button type="primary" htmlType="submit">
              {isEditMode ? "Update" : "Add"}
            </Button>
            <Button type="primary" danger className="cancel-btn">
              Clear
            </Button>
          </Form.Item>
        </Form>
      </Modal>
    </div>
  );
};

export default EmbassyDetails;
